// src/pages/MediaTypeOverviewPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import './MediaTypeOverviewPage.css'; // Assumes CSS copied from Flask static

const MediaTypeOverviewPage = ({ apiBaseUrl }) => {
  const [mediaCards, setMediaCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaCards = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/api/overview`, {
          credentials: 'include', // Match Flask's session auth
        });
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        const data = await res.json();
        console.log('Fetched media cards:', data);
        setMediaCards(data.media_cards || []);
      } catch (err) {
        console.error('Error fetching media cards:', err);
        setError('Failed to load media types');
      } finally {
        setLoading(false);
      }
    };

    fetchMediaCards();
  }, [apiBaseUrl]);

  if (loading) {
    return <div>Loading media types...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h1 className="overview-title">Browse Media Types</h1>
      <div className="media-type-grid">
        {mediaCards.map((card, index) => (
          <div
            key={index}
            className="media-type-card"
            style={{
              '--bg-url': `url('${card.images[0] || 'static/default.jpg'}')`,
            }}
          >
            <div className="card-background"></div>
            <div className="card-content">
              <div className="card-left">
                <h2>{card.label}</h2>
                <p>{card.description}</p>
                <Link to={`/media-list/${card.name}`} className="card-link">
                  <b>
                    View {card.label}
                    <img
                      src="/static/icons/arrow-right-solid.svg"
                      className="icon"
                      alt="Arrow right"
                      style={{ paddingLeft: '2px' }}
                    />
                  </b>
                </Link>
              </div>
              <div className="card-right">
                {card.images.map((image, imgIndex) => (
                  <img
                    key={imgIndex}
                    src={`${image}`}
                    alt="Preview"
                    className="preview-thumb"
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaTypeOverviewPage;